import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationNl from "./locales/nl/translation.json";
import siteNl from "./locales/nl/site.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "en",
    supportedLngs: ["en", "nl"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["navigator"],
      caches: [],
    },

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
        site: {},
      },
      nl: {
        translations: translationNl,
        site: siteNl,
      },
    },
    ns: ["translations", "site"],
    defaultNS: "translations",
  });

const updateDocumentLanguage = (language: string) => {
  document.documentElement.lang = language.split("-")[0];
};

i18n.on("languageChanged", updateDocumentLanguage);
updateDocumentLanguage(i18n.language || "en");

export default i18n;
